export type OrderFactSource = {
  vendor?: string | null;
  vendor_id?: string | null;
  vendor_reference?: string | null;
  vendor_specific_account?: string | null;
  connect_order_report?: {
    connect_order_id?: string | null;
    reference_id?: string | null;
  } | null;
};

const text = (value?: string | null) => (value || '').trim();

export const orderVendor = (source: OrderFactSource) => {
  const vendor = text(source.vendor);
  if (vendor) return vendor;
  if (source.connect_order_report) return 'connect';
  return '';
};

export const orderIdValue = (source: OrderFactSource) => {
  const connectId = text(source.connect_order_report?.connect_order_id);
  if (source.connect_order_report && connectId) return connectId;
  return text(source.vendor_id);
};

export const referenceIdValue = (source: OrderFactSource) => {
  const connectReference = text(source.connect_order_report?.reference_id);
  if (source.connect_order_report && connectReference) return connectReference;
  return text(source.vendor_reference);
};

export const packageValue = (source: OrderFactSource) => {
  if (orderVendor(source).toLowerCase() !== 'connect') return '';
  return text(source.vendor_specific_account);
};

export const factLabel = (vendor: string, kind: 'Order ID' | 'Reference ID') => (vendor ? `${vendor} ${kind}` : kind);

export const orderFactLines = (source: OrderFactSource) => {
  const vendor = orderVendor(source);
  return [
    [factLabel(vendor, 'Order ID'), orderIdValue(source)],
    [factLabel(vendor, 'Reference ID'), referenceIdValue(source)],
    ['Vendor Specific Account', packageValue(source)],
  ].filter(([, value]) => value) as [string, string][];
};
